module.exports = __webpack_public_path__ + "static/media/bars.117bd7ca.svg";